import { render, staticRenderFns } from "./Banklist.vue?vue&type=template&id=40f875b3"
import script from "./Banklist.vue?vue&type=script&lang=js"
export * from "./Banklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports